import { EGRAHMANTREE_URL, FLAGSHIP } from '../config/site';

export default function EgrahmantreeProofBand() {
  if (!FLAGSHIP) return null;

  return (
    <section className="section proof-band" style={{ '--product-accent': FLAGSHIP.accent }}>
      <div className="container proof-band__inner">
        <div className="proof-band__content">
          <p className="proof-band__label">Live product proof</p>
          <h2>{FLAGSHIP.name} runs in production every day</h2>
          <p>
            Our flagship consumer platform in Jaipur — verified professionals, payments, field teams, and
            full admin operations. We build what we operate.
          </p>
          <ul className="proof-band__stats">
            <li>Live marketplace</li>
            <li>Mobile + web</li>
            <li>Jaipur, Rajasthan</li>
          </ul>
        </div>
        <div className="proof-band__visual">
          {FLAGSHIP.heroImage && (
            <img src={FLAGSHIP.heroImage} alt={`${FLAGSHIP.name} app preview`} loading="lazy" />
          )}
          <a
            href={EGRAHMANTREE_URL}
            className="btn btn--product"
            style={{ '--product-accent': FLAGSHIP.accent }}
            target="_blank"
            rel="noopener noreferrer"
          >
            Visit egrahmantree.com
          </a>
        </div>
      </div>
    </section>
  );
}
